import { ModalDialog } from "@rothoblaas/design-system";
import type { Translation } from "../../../../hooks/useTranslations";
import styles from "../LockCalculator.module.css";

export type HelpContent = { text: string; image?: string };

type Props = { content: HelpContent | null; onClose: () => void; t: Translation };

export const HelpModal = ({ content, onClose, t }: Props) =>
  content ? (
    <ModalDialog onClose={onClose} title={t.common.help} className={styles.helpModalContent}>
      <div className={styles.helpModalBody}>
        {content.image && <img src={content.image} alt={t.lockCalculatorModule.helpModal.illustrationAlt} className={styles.helpModalImage} />}
        <p className={styles.helpModalText}>{content.text}</p>
      </div>
    </ModalDialog>
  ) : null;
